$(function () {
  return $("[data-toggle=\"tooltip\"]").tooltip()
})
